export enum TableFilter {
  ALL = 0,
  ACTIVE_ONLY = 1
}
